var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import './material-design-init.js';
import { SignalWatcher } from '@lit-labs/signals';
import { cfAuthState, cfLogout, initializeCfAuth, startCfLoginPopup, startCfLoginRedirect, } from '@df/state';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import './material-design-init.js';
/** Protects slotted content with a Cloudflare Access session. */
let DfStandardPioneerAuthWrapper = class DfStandardPioneerAuthWrapper extends SignalWatcher(LitElement) {
    constructor() {
        super();
        this.handleLogin = async () => {
            this.interactionError = null;
            try {
                if (this.usePopup)
                    await startCfLoginPopup();
                else
                    startCfLoginRedirect();
            }
            catch (error) {
                this.interactionError =
                    error instanceof Error ? error.message : 'Sign-in failed';
            }
        };
        this.handleLogout = (event) => {
            if (event.altKey) {
                this.showHideUser = !this.showHideUser;
                return;
            }
            cfLogout();
        };
        this.headless = false;
        this.showHideUser = false;
        this.bkgrd = null;
        this.sessionUrl = '/cf-auth/_protected/whoami';
        this.loginUrl = '/cf-auth/_protected/login';
        this.logoutUrl = '/cdn-cgi/access/logout';
        this.usePopup = false;
        this.interactionError = null;
        this.lastAnnouncedUser = undefined;
    }
    connectedCallback() {
        super.connectedCallback();
        void initializeCfAuth({
            sessionUrl: this.sessionUrl,
            loginUrl: this.loginUrl,
            logoutUrl: this.logoutUrl,
        });
    }
    updated() {
        const stateSnapshot = cfAuthState.get();
        if (!stateSnapshot.initialized)
            return;
        if (stateSnapshot.authUser === this.lastAnnouncedUser)
            return;
        this.lastAnnouncedUser = stateSnapshot.authUser;
        this.dispatchEvent(new CustomEvent('df-standard-pioneer-auth-wrapper-user-changed', {
            detail: { newValue: stateSnapshot.authUser },
            bubbles: true,
            composed: true,
        }));
    }
    static { this.styles = css `
    :host {
      display: block;
      font-family: var(--df-font-family, 'Roboto', sans-serif);
    }

    .full-screen {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 16px;
      box-sizing: border-box;
      min-height: 100vh;
      width: 100%;
      padding: 24px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-color: var(--md-sys-color-surface, #fff);
      color: var(--md-sys-color-on-surface, #1b1b1f);
    }

    .full-width-div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;
      min-height: 50px;
      padding: 0 12px;
      background: var(--md-sys-color-surface-container, #eeeef2);
      border-radius: 5px;
    }

    .identity {
      display: flex;
      align-items: center;
      gap: 10px;
      min-width: 0;
    }

    .user-photo {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
    }

    .user-name {
      margin: 0;
      overflow: hidden;
      font-size: 1.125rem;
      font-weight: 500;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .user-json {
      margin: 16px;
      padding: 16px;
      overflow-x: auto;
      border-radius: 8px;
      background: var(--md-sys-color-surface-container, #f0f0f0);
    }

    .user-json pre {
      margin: 0;
      font-family: var(--df-monospace-font-family, monospace);
      font-size: 0.875rem;
    }

    .error {
      color: var(--md-sys-color-error, #b3261e);
      text-align: center;
    }
  `; }
    render() {
        const snapshot = cfAuthState.get();
        const error = this.interactionError ?? snapshot.error;
        if (snapshot.authState === 'idle' || snapshot.authState === 'loading') {
            return html `
        <div class="full-screen" aria-label="Checking authentication">
          <md-circular-progress indeterminate></md-circular-progress>
        </div>
      `;
        }
        if (snapshot.authState !== 'authenticated' || !snapshot.authUser) {
            return this.renderLogin(error);
        }
        if (this.headless)
            return html `<slot></slot>`;
        return html `
      ${this.renderHeader(snapshot.authUser)}
      ${this.showHideUser ? this.renderUserJson(snapshot.authUser) : nothing}
      <slot></slot>
    `;
    }
    renderLogin(error) {
        const styles = this.bkgrd ? { backgroundImage: `url(${this.bkgrd})` } : {};
        return html `
      <div class="full-screen" style=${styleMap(styles)}>
        ${error ? html `<p class="error" role="alert">${error}</p>` : nothing}
        <md-filled-button @click=${this.handleLogin}>Sign in</md-filled-button>
      </div>
    `;
    }
    renderHeader(user) {
        return html `
      <div class="full-width-div">
        <div class="identity">
          ${user.picture
            ? html `<img class="user-photo" src=${user.picture} alt="" />`
            : nothing}
          <h2 class="user-name">${user.name ?? user.email}</h2>
        </div>
        <md-text-button @click=${this.handleLogout} aria-label="Sign out">
          Log out
        </md-text-button>
      </div>
    `;
    }
    renderUserJson(user) {
        return html `<div class="user-json">
      <pre>${JSON.stringify(user, null, 2)}</pre>
    </div>`;
    }
};
__decorate([
    property({ type: Boolean })
], DfStandardPioneerAuthWrapper.prototype, "headless", void 0);
__decorate([
    property({ type: Boolean, attribute: 'show-hide-user' })
], DfStandardPioneerAuthWrapper.prototype, "showHideUser", void 0);
__decorate([
    property({ type: String })
], DfStandardPioneerAuthWrapper.prototype, "bkgrd", void 0);
__decorate([
    property({ type: String, attribute: 'session-url' })
], DfStandardPioneerAuthWrapper.prototype, "sessionUrl", void 0);
__decorate([
    property({ type: String, attribute: 'login-url' })
], DfStandardPioneerAuthWrapper.prototype, "loginUrl", void 0);
__decorate([
    property({ type: String, attribute: 'logout-url' })
], DfStandardPioneerAuthWrapper.prototype, "logoutUrl", void 0);
__decorate([
    property({ type: Boolean, attribute: 'use-popup' })
], DfStandardPioneerAuthWrapper.prototype, "usePopup", void 0);
__decorate([
    state()
], DfStandardPioneerAuthWrapper.prototype, "interactionError", void 0);
DfStandardPioneerAuthWrapper = __decorate([
    customElement('df-standard-pioneer-auth-wrapper')
], DfStandardPioneerAuthWrapper);
export { DfStandardPioneerAuthWrapper };
//# sourceMappingURL=df-standard-pioneer-auth-wrapper.js.map